import TTSLookingIconDsk from "@assets/ttsIcons/ttsListenDesktop.svg";
import TTSLookingIconMbl from "@assets/ttsIcons/ttsListenMobile.svg";

export default function TTSLookingBanner() {
  return (
    <>
      <div className="relative flex items-end gap-3.5 justify-between md:justify-self-end font-semibold font-secondary text-brand-primary">
        <div className="flex items-start -mt-4 md:mt-0 md:items-end flex-col md:flex-row">
          <p className="leading-[120%] mb-0 text-xs md:text-md">
            Ikuti berita terkini.
          </p>
          <p className="!leading-[110%] mb-0 italic text-md md:text-2xl">
            Dengar di mana-mana sahaja.
          </p>
        </div>
        <picture className="absolute -top-9 right-0 md:static">
          <source media="(min-width: 768px)" srcSet={TTSLookingIconDsk} />
          <img src={TTSLookingIconMbl} alt="Listen on the go" />
        </picture>
      </div>
    </>
  );
}
